<div class="table-container mat-elevation-z2">
  <div class="mat-table">
    <mat-table [dataSource]="dataSource" matSortDisableClear>
      <ng-container matColumnDef="{{ columns.STUDENT_ID }}">
        <mat-header-cell *matHeaderCellDef>
          {{ columns.STUDENT_ID }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.studentExtId }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.STUDENT_NAME }}">
        <mat-header-cell *matHeaderCellDef>
          {{ columns.STUDENT_NAME }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.name }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.CHECK_IN_TIMES }}">
        <mat-header-cell *matHeaderCellDef>
          {{ columns.CHECK_IN_TIMES }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="time-container">
            <span *ngFor="let time of row.checkInTimes">
              {{ time }}
            </span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.CHECK_OUT_TIMES }}">
        <mat-header-cell *matHeaderCellDef>
          {{ columns.CHECK_OUT_TIMES }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="time-container">
            <span *ngFor="let time of row.checkOutTimes">
              {{ time }}
            </span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.STUDENT_STATUS }}">
        <mat-header-cell  *matHeaderCellDef>
          {{ columns.STUDENT_STATUS }}
        </mat-header-cell>
        <mat-cell  *matCellDef="let row">
           <div *ngIf="studentStatus(row) === 'at-event'" class="at-event-status-pill">At Event</div>
            <div *ngIf="studentStatus(row) === 'left-event'" class="left-event-status-pill">Left Event</div>
        </mat-cell>
      </ng-container>
      <ng-container class="action-row" matColumnDef="{{ columns.ACTION }}">
        <mat-header-cell class="action-column-header" *matHeaderCellDef>
          {{ columns.ACTION }}
        </mat-header-cell>
        <mat-cell class="action-column-cell" *matCellDef="let row">
          <button
            [disabled]="isLoading || shouldDisableCheckInOut(row)"
            mat-flat-button
            [class]="studentStatus(row)"
            *ngIf="started"
            (click)="handleButtonAction(row)">
            {{ getButtonLabel(row) }}
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let code; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>
